import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

/** Matn chegarasi (`TEXT_LIMITS` dan): pastda `12/300` va yetmasa "Kamida N ta belgi". */
export interface CharCount {
  value: string;
  min: number;
  max: number;
}

/**
 * Maydon ostidagi qator: chapda xato / "Kamida N ta belgi" / ko'rsatma, o'ngda belgilar hisoblagichi.
 * Server `trim()` dan keyin tekshiradi — minimum ham shunday; hisoblagich esa maxLength kabi xom uzunlik.
 */
export function CharHint({
  count,
  error,
  hint,
}: {
  count?: CharCount;
  error?: string | null;
  hint?: ReactNode;
}) {
  const { t } = useTranslation();
  const short = !!count && count.min > 0 && count.value.trim().length < count.min;
  const note = error ? (
    <span className="text-sm text-destructive">{error}</span>
  ) : short ? (
    <span className={count.value.trim() ? 'text-amber' : 'text-hint'}>
      {t('common.minChars', { count: count.min })}
    </span>
  ) : hint ? (
    <span className="text-hint">{hint}</span>
  ) : null;
  if (!note && !count) return null;
  return (
    <div className="mt-1 flex items-start justify-between gap-3 px-1 text-xs">
      <span className="min-w-0">{note}</span>
      {count && (
        <span
          className={`shrink-0 tabular-nums ${count.value.length >= count.max ? 'text-amber' : 'text-hint'}`}
        >
          {count.value.length}/{count.max}
        </span>
      )}
    </div>
  );
}

export function Field({
  label,
  hint,
  error,
  count,
  children,
}: {
  label: string;
  hint?: ReactNode;
  error?: string | null;
  count?: CharCount;
  children: ReactNode;
}) {
  return (
    // <label> emas: ichida bir nechta tugma bo'lsa, bo'sh joyga bosish birinchisini bosib yuboradi.
    <div className="mb-3 block">
      <span className="mb-1.5 block px-1 text-sm font-semibold text-muted">{label}</span>
      {children}
      <CharHint count={count} error={error} hint={hint} />
    </div>
  );
}
